import * as React from 'react';

const UpgradeIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    fill="none"
    viewBox="0 0 13 14"
  >
    <path
      fill="#FFC000"
      d="M5.994.787a.4.4 0 0 1 .569 0L10.8 5.07a.4.4 0 0 1-.284.681H2.04a.4.4 0 0 1-.284-.681z"
    ></path>
    <path
      fill="#FFC000"
      d="M4.278 5.5h4v4h-4zM4.278 10.5h4v1h-4zM4.278 12.5h4v1h-4z"
    ></path>
  </svg>
);

export default UpgradeIcon;
